import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Link2, ShieldCheck } from "lucide-react";

const READ_SCOPES = "pages_show_list, pages_read_engagement, pages_read_user_content, read_insights, instagram_basic, instagram_manage_insights, ads_read";
const STEPS = [
  "Su Instagram: Impostazioni > Tipo di account: deve essere Professionale (Business) e collegato alla pagina Facebook La Mora.",
  "Vai su developers.facebook.com/apps > Crea app > tipo Business e collegala al portfolio aziendale di La Mora. Nome: Gestionale La Mora.",
  "Apri business.facebook.com/settings > Utenti > Utenti di sistema > Aggiungi. Nome: Gestionale, ruolo: Dipendente (non amministratore).",
  "Sull'utente di sistema clicca Assegna risorse: Pagina La Mora, account Instagram e account pubblicitario, attivando SOLO i permessi di visualizzazione (statistiche/prestazioni), nessun controllo completo. Assegna anche l'app Gestionale La Mora.",
  `Clicca Genera token: scegli l'app, scadenza Mai e seleziona SOLO questi permessi di lettura: ${READ_SCOPES}.`,
  "Copia il token e incollalo qui sotto. Se contiene permessi di modifica il gestionale lo rifiuta.",
];

export const SocialConnect = ({ isOwner, reauth }) => {
  const qc = useQueryClient();
  const [token, setToken] = useState("");
  const connect = useMutation({
    mutationFn: async () => (await api.post("/social/connect", { user_token: token })).data,
    onSuccess: (r) => {
      toast.success(`Collegati @${r.ig_username} e ${r.page_name}: sto scaricando i dati, ci vuole qualche minuto`);
      qc.invalidateQueries({ queryKey: ["social"] });
    },
    onError: (e) => toast.error(e?.response?.data?.detail || "Collegamento non riuscito"),
  });
  return (
    <Card className="max-w-3xl p-6" data-testid="social-connect">
      <h3 className="mb-1 flex items-center gap-2 font-display text-lg font-semibold"><Link2 className="h-4 w-4 text-primary" />{reauth ? "Ricollega i profili" : "Collega Instagram e Facebook dal Business Manager"}</h3>
      <p className="mb-2 text-sm text-muted-foreground">{reauth ? "Meta ha revocato l'accesso: genera un nuovo token dall'utente di sistema e ricollega." : "Una sola volta, circa 15 minuti. Poi i dati si aggiornano da soli ogni giorno."}</p>
      <p className="mb-4 flex items-center gap-1.5 text-xs text-emerald-400"><ShieldCheck className="h-3.5 w-3.5" />Solo lettura: il gestionale non può pubblicare, modificare o creare sponsorizzate.</p>
      <ol className="mb-5 list-decimal space-y-1.5 pl-5 text-sm">{STEPS.map((s) => <li key={s}>{s}</li>)}</ol>
      {isOwner ? (
        <div className="space-y-3">
          <div>
            <Label htmlFor="social-token" className="text-xs">Token dell'utente di sistema</Label>
            <Input id="social-token" type="password" value={token} onChange={(e) => setToken(e.target.value)} className="mt-1" data-testid="social-token" autoComplete="off" />
          </div>
          <Button className="md:w-40" disabled={connect.isPending || !token} onClick={() => connect.mutate()} data-testid="social-connect-btn">
            {connect.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Collega
          </Button>
        </div>
      ) : <p className="text-sm text-amber-400">Solo il proprietario può collegare i profili.</p>}
    </Card>
  );
};
